import { Link } from "@/components/site/LocaleLink";
import { ArrowUpRight } from "lucide-react";
import { useLang, useL } from "@/context/LanguageContext";
import { getCategory } from "@/data/products";
import { Picture } from "@/components/site/Picture";

export const ProductCard = ({ product, index = 0 }) => {
  const { t } = useLang();
  const L = useL();
  const cat = getCategory(product.category);
  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-line bg-white transition-all duration-500 hover:-translate-y-1 hover:border-forest/30 hover:shadow-[0_18px_40px_rgba(24,58,55,0.08)]"
    >
      <div className="relative aspect-square overflow-hidden bg-gradient-to-b from-sage/40 to-mint">
        <Picture
          img={product.image}
          alt={L(product.name)}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <span className="absolute top-4 start-4 rounded-full bg-white/90 px-3 py-1 text-[11px] font-semibold text-forest backdrop-blur-sm">
          {L(product.tag)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="eyebrow text-gold-ink">{L(cat.name)}</p>
        <h3 className="mt-2 font-display text-lg font-bold leading-snug text-forest">{L(product.name)}</h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm text-stone">{L(product.tagline)}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-forest">
          {t.featured.view}
          <ArrowUpRight className="h-4 w-4 text-gold transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 rtl-flip" />
        </span>
      </div>
    </Link>
  );
};
